<template>
    <transition name="expand" @enter="enter" @after-enter="afterEnter" @leave="leave">
        <slot />
    </transition>
</template>

<script lang="ts">
    import { defineComponent } from 'vue';

    export default defineComponent({
        name: 'TransitionExpand',
        methods: {
            enter(element: any) {
                const width = getComputedStyle(element).width;
                element.style.width = width;
                element.style.position = 'absolute';
                element.style.visibility = 'hidden';
                element.style.height = 'auto';

                const height = getComputedStyle(element).height;
                element.style.width = null;
                element.style.position = null;
                element.style.visibility = null;
                element.style.height = 0;

                requestAnimationFrame(() => {
                    element.style.height = height;
                });
            },
            afterEnter(element: any) {
                element.style.height = 'auto';
            },
            leave(element: any) {
                const height = getComputedStyle(element).height;
                element.style.height = height;

                requestAnimationFrame(() => {
                    element.style.height = 0;
                });
            },
        },
        setup() {
            return {};
        },
    });
</script>

<style lang="scss" scoped>
    @forward './TransitionExpand.scss';
</style>
